<template>
  <BaseButton
    bare
    variant=""
    class="modal-close-btn"
    :aria-label="$t('common.close')"
    @click="$emit('close')"
  >
    <font-awesome-icon icon="fa-solid fa-xmark" />
  </BaseButton>
</template>

<script>
  import BaseButton from '@/components/ui/BaseButton.vue'

  export default {
    name: 'ModalCloseButton',
    components: {
      BaseButton
    },
    emits: ['close']
  }
</script>

<style scoped lang="scss">
  .modal-close-btn {
    background: transparent;
    border: none;
    font-size: 0.85rem;
    color: #95a5a6;
    cursor: pointer;
    padding: 0.3rem;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 1.75rem;
    height: 1.75rem;

    &:hover {
      background-color: #f8f9fa;
      color: #e74c3c;
    }
  }
</style>
